import { useEffect } from "react";
import confetti from "canvas-confetti";

const EmojiCannon = ({ emoji, position }) => {
  useEffect(() => {
    if (!emoji || !position) return;

    confetti({
      particleCount: 100,
      spread: 120,
      origin: {
        x: position.x / window.innerWidth,
        y: position.y / window.innerHeight,
      },
      shapes: ["text"],
      scalar: 0.9,
      ticks: 100,
      gravity: 0.5,
      shapesOptions: {
        text: { value: [emoji] },
      },
    });
  }, [emoji, position]);

  return null;
};

export default EmojiCannon;
